import { MODAL, SPOTLIGHTS, NONE } from '../../common/constants';

export const STEPS = [MODAL, SPOTLIGHTS, NONE] as const;
